export const defaultHandler: () => void = () => {};
